module.exports = __webpack_public_path__ + "static/img/v_2.b0f6a5ce.png";